import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';

import { translate } from 'base/shared/Localization';

import HeaderLang from 'components/header-lang';
import Footer from 'components/Layout/Footer';

import HomeActions from 'datamodel/Home/actions';
// import RoomCollections from 'app/components/RoomCollections/RoomCollections';

import { LINKED_CARDS, META_DATA, META_DATA_PLUS, SEO_LINKS } from './constants';
import { getBadiPlusHomePath, getHomePath, isBadiPlusPath } from './routes';

import RoomSwitcher from 'app/v2/pages/Home/components/Switch';
import AllRooms from 'app/v2/pages/Home/components/AllRooms';
import Featured from 'app/v2/pages/Home/components/Featured';
import AnimatedSection from './components/animated-section';
import SeoLinks from './components/seo-links';

const ALL_ROOMS_OPTION = 'all-rooms';
const BADI_PLUS_OPTION = 'badi-plus';

const Home = ({ location, openLogin, router }) => {
  const [showDistribution, setShowDistribution] = useState(true);

  // The active tab is derived from the URL (SPEC-0001): /plus and /es/plus render Badi Plus.
  const isBadiPlus = isBadiPlusPath(location?.pathname);
  const activeOption = isBadiPlus ? BADI_PLUS_OPTION : ALL_ROOMS_OPTION;
  const metaData = isBadiPlus ? META_DATA_PLUS : META_DATA;

  const dispatch = useDispatch();
  const badiPlusCollection = useSelector((state) => state.Home?.badiPlusCollection);
  const token = useSelector((state) => state.Auth?.access_token);

  LINKED_CARDS.resources[0].clickHandler = openLogin;

  const handleOptionChange = (option) => {
    if (option === activeOption) return;

    router.push(option === BADI_PLUS_OPTION ? getBadiPlusHomePath() : getHomePath());
  };

  useEffect(() => {
    if (token) {
      dispatch(HomeActions.getBadiPlusCollection({ token }));
    }
  }, [dispatch, token]);

  return (
    <>
      <RoomSwitcher activeOption={activeOption} onOptionChange={handleOptionChange} />
      {isBadiPlus ? <Featured /> : <AllRooms location={location} />}

      <AnimatedSection>
        <SeoLinks {...SEO_LINKS} key="seo-links" />
      </AnimatedSection>
      <Helmet meta={translate(metaData.meta, 'content')} title={translate(metaData.title)} />
      <HeaderLang canonicalUrl={location?.pathname} relativePath={location?.pathname} />
      <Footer campaign="home_footer" />
    </>
  );
};

Home.defaultProps = {
  countryCode: null,
  location: {},
};

export default withRouter(Home);
